import './desktop_nav.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import first from 'lodash/first';

import DefaultNavigationMenu from './desktop.menu_default.jsx';
import NavigationMenuWithToplevelSubmenuLinks from './desktop.menu_with_toplevel_submenu_links.jsx';


class Navigation extends Component {

  render() {
    const { 
      MenuItemComponent, 
      SubmenuItemComponent, 
      SubmenuDropdownComponent,
      currentSubpage, 
      currentSubmenuItems,
      lastClickedSubmenuItemId, 
      menuItems, 
      submenuItemsBySubpageId, 
      isFixed, 
      shouldPreventDropdowns,
      shouldShowSubmenuNavigationAsToplevel,
      children,
      tellRef,
      isUsingLegacyHeader,
      isTranslationsEnabled,
      appliedLanguages,
      currentLanguageIso,
      defaultLanguageIso,
      onLanguageChange
    } = this.props;

    return (
      <div
        className={classNames({
          'navigation-links': isUsingLegacyHeader,
          'dasher-navigation-links': !isUsingLegacyHeader,
          'fixed-navigation-links': isFixed,
          'prevent-dropdowns': shouldPreventDropdowns,
          'translation-enabled': isTranslationsEnabled
        })}
        ref={tellRef}
      >

        {
          shouldShowSubmenuNavigationAsToplevel ?
            <NavigationMenuWithToplevelSubmenuLinks
              menuItem={first(menuItems)} 
              currentSubpage={currentSubpage} 
              MenuItemComponent={MenuItemComponent}
              SubmenuItemComponent={SubmenuItemComponent}
              currentSubmenuItems={currentSubmenuItems}
              lastClickedSubmenuItemId={lastClickedSubmenuItemId}
              isTranslationsEnabled={isTranslationsEnabled}
              appliedLanguages={appliedLanguages}
              currentLanguageIso={currentLanguageIso}
              defaultLanguageIso={defaultLanguageIso}
              onLanguageChange={onLanguageChange}
            />
          :
            <DefaultNavigationMenu 
              menuItems={menuItems} 
              currentSubpage={currentSubpage} 
              MenuItemComponent={MenuItemComponent}
              submenuItemsBySubpageId={submenuItemsBySubpageId}
              currentSubmenuItems={currentSubmenuItems}
              SubmenuItemComponent={SubmenuItemComponent}
              SubmenuDropdownComponent={SubmenuDropdownComponent}
              lastClickedSubmenuItemId={lastClickedSubmenuItemId}
              isTranslationsEnabled={isTranslationsEnabled}
              appliedLanguages={appliedLanguages}
              currentLanguageIso={currentLanguageIso}
              defaultLanguageIso={defaultLanguageIso}
              onLanguageChange={onLanguageChange}
            />
        }
        {children}
      </div>
    );
  }


}

Navigation.propTypes = {
  currentSubpage: PropTypes.object.isRequired,
  menuItems: PropTypes.array.isRequired,
  submenuItemsBySubpageId: PropTypes.object,
  isFixed: PropTypes.bool,
  MenuItemComponent: PropTypes.oneOfType([PropTypes.instanceOf(Component), PropTypes.func]).isRequired
};

export default Navigation;
